!function($) {

  // Add custom JavasScript here
  // --------------------------

  // Document ready
  $(function() {
    
    $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
      if ($('#agree').is(':checked')) {
        $(this).submit();
      }
      else {
        alert("You must agree with the terms and conditions of sales to check out.");
        return false;
      }
    });
    
  });
  
}(jQuery);

function maybeDisplayVariantsInSearchList(self) {
  const $productItemElem = jQuery(self);
  if($productItemElem.hasClass("exact-match")) return;
  
  const $productItemVariantScript = $productItemElem.find('script.goe-filter-product-variants');
  if($productItemVariantScript.length == 0) return;

  const productVariants = JSON.parse($productItemVariantScript.text());
  const activeSearchInput = bfs_SearchInputs.filter((input, index, arr) => {
    return input.$element.val();
  });
  let searchTerm = '';
  if(activeSearchInput.length == 0) {
    searchTerm = jQuery('#boost-pfs-search-box-0').val();
  }
  else {
    searchTerm = activeSearchInput[0].$element.val().toLowerCase();
  }
  
  // do we have an exact match with the term searched and this product?
  const exactMatch = productVariants.filter(product => product.sku === searchTerm);
  if(exactMatch.length == 1) {
    $productItemElem.addClass("exact-match");
    $productItemElem.data('exactMatch', exactMatch[0]);
    $productItemElem.find('a').each((index, elem) => {
      const baseUrl = jQuery(elem).attr('href');
      jQuery(elem).attr('href', baseUrl + '?variant=' + exactMatch[0].id);
      if(jQuery(elem).hasClass("boost-pfs-filter-product-item-title")) {
        let colorOptText = exactMatch[0].color[0] ?? '';
        jQuery(elem).text( `${jQuery(elem).text()} - ${colorOptText}`);
      }
    });
    $productItemElem.find('.goe-main-sku').each((index, elem) => {
      jQuery(elem).text(`${exactMatch[0].sku}`);
    });
    // $productItemElem.find('.boost-pfs-filter-product-item-flip-image').remove();
    $productItemElem.find('img').each((index, elem) => {
      const $img = jQuery(elem);
      if($img.hasClass('boost-pfs-filter-product-item-main-image')) {
        $img.attr('data-img-flip-src',exactMatch[0].img).attr('data-img-flip-srcset', '').addClass('goe-exact-match-img');
      } 
      $img.attr('srcset', '').attr('data-srcset', '');
      $img.attr('src', exactMatch[0].img);
      
    });
  } // else { do nothing }
}

const slugify = str =>
  str
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '');





